import React from 'react';
import QuoteForm from '../components/QuoteForm';

const QuotePage = () => {
    return (
        <section className="section section--quote-page">
            <div className="container">
                <h1 className="section__title">Request Your Free Cleaning Quote</h1>
                <p className="section__subtitle">
                    Share a few details about your home, office, or rental property. We’ll review your
                    request and send a personalized quote.
                </p>

                <QuoteForm mode="full" />

                <div className="quote-faq">
                    <h2>Common Questions</h2>
                    <div className="quote-faq__item">
                        <h3>Is the quote really free?</h3>
                        <p>
                            Yes. There is no cost or obligation. We’ll review your information and let you
                            know what we recommend and what it would cost.
                        </p>
                    </div>
                    <div className="quote-faq__item">
                        <h3>Do you bring your own supplies?</h3>
                        <p>
                            Yes. We bring our own equipment and eco-friendly cleaning products. If you have
                            specific products you prefer, we can use those too.
                        </p>
                    </div>
                    <div className="quote-faq__item">
                        <h3>Which areas do you serve?</h3>
                        <p>
                            We regularly serve Guelph, Kitchener, Waterloo, and Cambridge. If you’re just
                            outside these areas, include your address and we’ll confirm.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default QuotePage;
